import WebSocketStore from 'core/classes/services/WebSocketStore'

import { IAplDocument } from '../models/aplDocument'

export const fetchAplDocuments = async (): Promise<IAplDocument[]> => {
  try {
    const wsClient = WebSocketStore.get('onboarding')
    const result = await wsClient.call<IAplDocument[]>({
      service: 'apl',
      action: 'get-apl-documents',
      payload: {
        page: 1,
        size: 1000,
      },
    })

    return result.data
  } catch (e) {
    return []
  }
}
